import { Box } from '@mui/material'
import { useEffect, useState } from 'react'
import { Title, useTranslate } from 'react-admin'
import { useLocation, useNavigate } from 'react-router-dom'

import { isHiddenKey, readHiddenKey, storeHiddenKey } from '../../lib/hiddenKey'
import { SostratSyncPanel } from '../molecules/SostratSyncPanel'

/**
 * The SÒSTRAT read for whoever holds the key, without a rebuild:
 * /hidden?key=<key> once, after which the browser remembers it. The key leaves
 * the URL (and history) whether it is right or not. Without a valid key the
 * page renders nothing.
 */
export const HiddenPage = () => {
  const translate = useTranslate()
  const navigate = useNavigate()
  const location = useLocation()
  // Read once: dropping it from the URL must not re-run the check without it.
  const [keyInUrl] = useState(() => new URLSearchParams(location.search).get('key'))
  const [unlocked, setUnlocked] = useState(false)

  useEffect(() => {
    if (keyInUrl !== null) void navigate('/hidden', { replace: true })
    // An object, so the check below reads the value the cleanup set, not the one at creation.
    const run = { cancelled: false }
    const expected = import.meta.env.VITE_HIDDEN_KEY_SHA256 as string | undefined
    const check = async () => {
      if (keyInUrl !== null && (await isHiddenKey(keyInUrl, expected))) {
        storeHiddenKey(keyInUrl)
        return true
      }
      const stored = readHiddenKey()
      return stored !== null && isHiddenKey(stored, expected)
    }
    void (async () => {
      const ok = await check()
      if (!run.cancelled) setUnlocked(ok)
    })()
    return () => {
      run.cancelled = true
    }
  }, [keyInUrl, navigate])

  if (!unlocked) return null
  return (
    <Box p={2}>
      <Title title={translate('pages.hidden.title')} />
      <SostratSyncPanel />
    </Box>
  )
}
